/* eslint-env browser */
import * as React from 'react'
import PropTypes from 'prop-types'
import isEmail from 'validator/lib/isEmail'
import request from 'axios'
import withTranslator from '../TranslatorProvider'

const AnalyticsService = require('../../../../common/client/analytics.js')

class LoginForm extends React.Component {
  constructor() {
    super()
    this.state = {
      email: '',
      password: '',
      hasClickedSubmit: false,
      loading: false,
    }

    this.handleSubmit = this.handleSubmit.bind(this)
  }

  handleSubmit(e) {
    e.preventDefault()
    const { loading, email, password } = this.state
    if (loading) {
      return
    }
    this.setState({ loginErrorMessage: null, loading: true })
    if (!isEmail(email) || !password || password.length < 6) {
      this.setState({ hasClickedSubmit: true, loading: false })
      return
    }
    request
      .post('/api/login', {
        username: email,
        password,
      })
      .then(() => {
        if (window.location.pathname === '/') {
          window.location = '/me/feed'
        } else {
          window.location.reload(true)
        }
      })
      .catch(err => {
        let message = 'errorSystem'
        if (err.response && err.response.status === 401) {
          message = 'invalidLoginPassword'
          if (err.data && err.data.message === 'not.confirmed') {
            message = 'notConfirmed'
          }
        }
        this.setState({ loginErrorMessage: message, loading: false })
      })
  }

  render() {
    const { loading, hasClickedSubmit, email, password, loginErrorMessage } = this.state

    const { translate } = this.props

    const emailTitle = translate('loginSignup.form.email.title')
    const passwordTitle = translate('loginSignup.form.password.title')
    const emailError = hasClickedSubmit && !isEmail(email)
    const passwordError = hasClickedSubmit && (!password || password.length < 6)

    return (
      <form className="form" onSubmit={this.handleSubmit}>
        <div className="field is-horizontal">
          <div className="field-label is-normal">
            <label className="label" htmlFor="input-email">
              {emailTitle}
            </label>
          </div>
          <div className="field-body">
            <div className="field">
              <p className="control is-expanded has-icons-left">
                <input
                  className={`input ${emailError ? 'is-danger' : ''}`}
                  type="email"
                  name="email"
                  id="input-email"
                  placeholder={emailTitle}
                  autoCorrect="off"
                  autoCapitalize="off"
                  onChange={e => {
                    this.setState({ email: e.target.value })
                  }}
                />
                <span className="icon is-small is-left">
                  <i className="fas fa-envelope" />
                </span>
              </p>
              {emailError && <p className="help is-danger">{translate('loginSignup.form.email.error')}</p>}
            </div>
          </div>
        </div>
        <div className="field is-horizontal">
          <div className="field-label is-normal">
            <label className="label" htmlFor="input-password">
              {passwordTitle}
            </label>
          </div>
          <div className="field-body">
            <div className="field">
              <p className="control is-expanded has-icons-left">
                <input
                  className={`input ${passwordError ? 'is-danger' : ''}`}
                  type="password"
                  name="password"
                  id="input-password"
                  placeholder={passwordTitle}
                  autoCorrect="off"
                  autoCapitalize="off"
                  onChange={e => {
                    this.setState({ password: e.target.value })
                  }}
                />
                <span className="icon is-small is-left">
                  <i className="fas fa-lock" />
                </span>
              </p>
              {passwordError && <p className="help is-danger">{translate('loginSignup.form.password.error')}</p>}
            </div>
          </div>
        </div>
        {loginErrorMessage && (
          <div className="field is-horizontal animated shake faster">
            <div className="field-label" />
            <div className="field-body">
              <div className="field">
                <div className="control">
                  <div className="notification is-danger">
                    {translate(`loginSignup.loginError.${loginErrorMessage}`)}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        <div className="field is-horizontal">
          <div className="field-label" />
          <div className="field-body">
            <div className="field">
              <div className="control">
                <button
                  type="submit"
                  onClick={AnalyticsService.trackEvent('LOGIN_EMAIL_PASSWORD')}
                  className={`button is-call-to-action ${loading ? 'is-loading' : ''}`}
                >
                  {translate('loginSignup.form.loginButton')}
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    )
  }
}

LoginForm.propTypes = {
  translate: PropTypes.func.isRequired,
}

module.exports = withTranslator(LoginForm)
